import { action, observable, set } from "mobx";
import UiMeet3dLevel from "~/constants/UiMeet3d/UiMeet3dLevel";

export default class CustomerDefaults {
  @observable autoplay = true;

  @observable galleryVisibility = null;

  @observable hasSendToFriend = true;

  @observable hasShowOtherTours = true;

  @observable initialNavigationModeDefault = "show";

  @observable maxPlayerAspectRatio = "9.99";

  @observable minPlayerAspectRatio = "0.01";

  @observable panningDuration = 0;

  @observable panningTime = 75;

  @observable sendTourStatsEveryNDays = 0;

  @observable sendTourStatsToCustomer = true;

  @observable sendTourStatsFreq = 7;

  @observable showMap = true;

  @observable showNeighborhood = true;

  @observable showPrintableFlyer = true;

  @observable slideshowTime = 3;

  @observable snapToFillThreshold = "0.30";

  @observable videoSlideshowMode = false;

  @observable videoSlideshowProgramMode = "random";

  @observable audioOption = "none";

  @observable audioId = null;

  /**
   * @property {number}
   */
  @observable uiMeet3dLevel = UiMeet3dLevel.NONE;

  constructor(data) {
    if (data !== undefined) {
      this.setData(data);
    }
  }

  @action
  setData(data) {
    set(this, data);
  }
}
